import React, { useState, useEffect, useMemo } from "react";
import left from "../Images/circled-left-chevron-svgrepo-com.svg";
import right from "../Images/circled-right-chevron-svgrepo-com.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function UniversitiesCarousel() {
  const [uniData, setUniData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch("https://easylearne.com/wp-json/acf/v3/pages/7");
        const data = await res.json();
        setUniData(data?.acf || {});
      } catch (error) {
        console.error("Error fetching universities data:", error);
      }
    };

    fetchData();
  }, []);

  const logos = useMemo(() => {
    if (!uniData) return [];

    return Object.keys(uniData)
      .filter((key) => key.startsWith("offline_image_"))
      .sort((a, b) => Number(a.split("_").pop()) - Number(b.split("_").pop()))
      .map((key, i) => ({
        id: i + 1,
        img: uniData[key],
      }));
  }, [uniData]);

  return (
    <section id="collaborations" className="container py-12 bg-white relative">
      <div className="px-5 text-center mx-auto relative">
        {/* <p className="text-3xl text-gray-500"></p> */}
        <h2 className="text-3xl font-bold mb-6">
         Domestic <span className="text-indigo-600">Online</span> University
        </h2>

        {/* LEFT Arrow */}
        <button
          className="uni-prev hidden md:flex absolute left-0 top-2/4 z-20 bg-emerald-100 p-2 rounded-full shadow-lg hover:bg-emerald-200 transition"
        >
          <img src={left} alt="left" />
        </button>

        {/* RIGHT Arrow */}
        <button
          className="uni-next hidden md:flex absolute right-0 top-2/4 z-20 bg-emerald-100 p-2 rounded-full shadow-lg hover:bg-emerald-200 transition"
        >
          <img src={right} alt="right" />
        </button>

        <div className="mx-10">
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: ".uni-prev",
              nextEl: ".uni-next",
            }}
            autoplay={{ delay: 2500, disableOnInteraction: false }}

            /* FIX 1: Enable loop only after slides exist */
            loop={logos.length > 1}

            /* FIX 2: WordPress DOM handling */
            observer={true}
            observeParents={true}

            spaceBetween={28}

            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 12 },
              480: { slidesPerView: 2, spaceBetween: 16 },
              768: { slidesPerView: 3, spaceBetween: 20 },
              1024: { slidesPerView: 4, spaceBetween: 28 },
            }}
            className="py-5"
          >
            {!uniData ? (
              <p className="text-gray-600 text-center">Loading...</p>
            ) : logos.length > 0 ? (
              logos.map((logo) => (
                <SwiperSlide key={logo.id}>
                  <div className="bg-gray-50 p-6 rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 flex justify-center items-center h-28">
                    <img
                      src={logo.img}
                      alt={`logo-${logo.id}`}
                      className="h-16 object-contain"
                    />
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <p className="text-gray-500">No universities added yet.</p>
            )}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
